import React, { Suspense } from 'react';
import { CssBaseline } from 'common/components';
import { ThemeProvider } from 'fronton-react';
import { Brands } from 'features/brands';
import type { BrandsProps } from 'features/brands/types';

export const BrandsWidget: React.FC<BrandsProps> = ({ ...props }) => {
  return (
    <Suspense>
      <ThemeProvider>
        <CssBaseline />
        <Brands {...props} />
      </ThemeProvider>
    </Suspense>
  );
};
